import { Avatar, AvatarProps } from "@mui/material";
import { avatarColor, avatarString } from "commons/ultilities";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { useStores } from "../../../mobx-stores/_root-store";
type ProfileAvatarProps = AvatarProps & {};
export const ProfileAvatar = observer((props: ProfileAvatarProps) => {
  const {
    authentication: { profile },
  } = useStores();
  const avatar = useMemo(() => {
    if (profile?.name) {
      return avatarString(profile?.name);
    }
    return "";
  }, [profile?.name]);

  const bgColor = useMemo(() => {
    if (profile?.name) {
      return avatarColor(profile?.name);
    }
    return undefined;
  }, [profile?.name]);
  return (
    <Avatar
      {...props}
      alt={profile?.name || ""}
      sx={{ ...props.sx, bgcolor: bgColor }}
    >
      {avatar}
    </Avatar>
  );
});
